var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import classnames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useLocation } from 'react-router-dom';
import { APP_SCROLL_CONTAINER_ID } from '../../constants/ids';
import { useDragAndDropUploadStyles } from './DragAndDropUpload.styles';
import { useDragAndDropUpload } from './useDragAndDropUpload';
export var appbarConnectorService = AppbarConnectorService.getInstance();
var DragAndDropUploadInternal = function (_a) {
    var _b, _c, _d, _e;
    var children = _a.children, scrollContentRef = _a.scrollContentRef;
    var _f = __read(useDragAndDropUpload(), 2), isDropping = _f[0], connectDropTarget = _f[1];
    useEffect(function () {
        if (scrollContentRef.current) {
            connectDropTarget(scrollContentRef.current);
        }
    }, [connectDropTarget, scrollContentRef]);
    var featureGates = (_b = useFeatureGates()) === null || _b === void 0 ? void 0 : _b.data;
    var visualRefreshEnabled = (_e = (_d = (_c = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _c === void 0 ? void 0 : _c.visualRefreshGates) === null || _d === void 0 ? void 0 : _d.visualRefreshEnabled) !== null && _e !== void 0 ? _e : false;
    var styles = useDragAndDropUploadStyles();
    return (React.createElement("div", { className: classnames(styles.scrollContent, isDropping && styles.containerActive, visualRefreshEnabled && styles.scrollContentNoShadow), "data-testid": "officehome-scroll-content", id: APP_SCROLL_CONTAINER_ID, ref: scrollContentRef }, children));
};
var DragAndDropUpload = function (_a) {
    var children = _a.children, scrollContentRef = _a.scrollContentRef;
    var hasFullDragAndDropRendered = useRef(false);
    var location = useLocation();
    var styles = useDragAndDropUploadStyles();
    if (location.pathname.includes('/chat') &&
        !hasFullDragAndDropRendered.current) {
        return (React.createElement("div", { className: styles.scrollContent, "data-testid": "officehome-scroll-content", id: APP_SCROLL_CONTAINER_ID, ref: scrollContentRef }, children));
    }
    hasFullDragAndDropRendered.current = true;
    return (React.createElement(DndProvider, { backend: HTML5Backend },
        React.createElement(DragAndDropUploadInternal, { scrollContentRef: scrollContentRef }, children)));
};
export default DragAndDropUpload;
//# sourceMappingURL=DragAndDropUpload.js.map